'use client'
import Image from 'next/image'
import { noto_sans } from '@/globalConstants';
import Devider from './Divider';
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import Link from 'next/link';

const Footer = () => {
    const BASE_CLASS = 'footer'
    const [isWebView, setIsWebView] = useState(false);
    const pathname = usePathname();
    const displayType = (pathname.split("/")[1] === 'learn-more' || pathname.split("/")[1] === 'learn-more-mobile') ? 'hidden' : 'flex';
    useEffect(() => {
        const userAgent = navigator.userAgent || '';

        // Check if user agent is for Flutter WebView
        const isAppWebView = /AppWebView/i.test(userAgent);

        setIsWebView(isAppWebView);
    }, []);

    return (
        <div>
            <div className="relative bottom-0 left-0 right-0 overflow-hidden">
                <div
                    className="w-full h-8 md:h-12 lg:h-24 mt-2 bg-repeat-x bg-[#FDF8E9] rotate-180"
                    style={{ backgroundImage: "url('/bottom-wave.svg')" }}
                ></div>
            </div>
            <footer id="contact" className={`${BASE_CLASS}__footer   bg-[#05574E] pt-[2rem] lg:pt-[4rem] pb-[1.45rem]   ${noto_sans.className} ${displayType} justify-start md:justify-center ${isWebView ? 'hidden' : ''}  `}>
                <div className='footer-conatiner grid items-center  gap-[1.2rem] md:gap-[1.5rem] lg:gap-[2rem] w-[95%] lg:w-[90%]     2xl:w-[70%] '>
                    <div className={`${BASE_CLASS}__footer__logo__download-now  flex flex-col gap-[48px] lg:flex-row justify-between  `}>
                        <div className='flex flex-col gap-[0.75rem] '>
                            <div className={`${BASE_CLASS}__footer__logo `}>
                                <Link href="/" className='flex justify-start md:justify-center lg:justify-start items-baseline'>
                                    <Image

                                        className="logo-flower-img  h-[48px] w-[250px] mt-[1rem]"
                                        src={`/updated-logo.svg`} alt="Dharmāyana Logo"
                                        height={48}
                                        width={250}
                                    />
                                </Link>
                            </div>
                            <div className={`${BASE_CLASS}__download-now ml-[0.75rem] md:ml-0`}>
                                <div className={`download-nudge__app-links  grid gap-3`}>

                                    <div className='flex justify-start md:justify-center lg:justify-start  gap-3'>
                                        <a
                                            href={process.env.NEXT_PUBLIC_KOCHAVA_LINK_ANDROID}
                                            target="_blank"

                                        ><Image
                                                id="play-store-header"
                                                src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/Play Store Badge.webp`}
                                                height={30}
                                                width={130}
                                                alt="Download the app for Android"
                                                className='h-[auto] hover:scale-110 transition delay-150 duration-300 ease-in-out '
                                            /></a>

                                        <a
                                            href={process.env.NEXT_PUBLIC_KOCHAVA_LINK_IOS}
                                            target="_blank"
                                        ><Image

                                                loading='eager'
                                                id="app-store-footer"
                                                src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/iOS Badge.webp`}
                                                height={1}
                                                width={1}
                                                alt="Download the app for iOS"
                                                className='h-[38px] w-[122px]  hover:scale-110 transition delay-150 duration-300 ease-in-out  '
                                            /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-12 sm:justify-around px-4 md:px-10 lg:px-0'>
                            <div className={`features-nav-bar flex flex-col  gap-[8px] md:items-center font-bold  ${noto_sans.className} tracking-[0.05rem] text-white text-[1rem]`}>

                                <ul className='flex flex-col  gap-[8px]'>
                                    <li className='text-[#B7C988] mb-2'>
                                        EXPLORE
                                    </li>
                                    {(BASE_CLASS === "footer") && <li className={`${BASE_CLASS}__nav-links__link cursor-pointer 
                                                hover:text-[#ebe793] hover:text-shadow 
                                                transition delay-150 duration-200 
                                                ease-in-out           
                                             `}>
                                        <Link href="/panchanga">Panchanga</Link>
                                    </li>}
                                    {(BASE_CLASS === "footer") && <li className={`${BASE_CLASS}__nav-links__link cursor-pointer 
                                                hover:text-[#ebe793] hover:text-shadow 
                                                transition delay-150 duration-200 
                                                ease-in-out  
                                                   
                                             `}>
                                        <Link href="/prarthana">Prarthana</Link>
                                    </li>}
                                    {(BASE_CLASS === "footer") && <li className={`${BASE_CLASS}__nav-links__link cursor-pointer 
                                                hover:text-[#ebe793] hover:text-shadow 
                                                transition delay-150 duration-200 
                                                ease-in-out           
                                             `}>
                                        <Link href="/festivals">Festivals</Link>
                                    </li>}
                                    {(BASE_CLASS === "footer") && <li className={`${BASE_CLASS}__nav-links__link cursor-pointer 
                                                hover:text-[#ebe793] hover:text-shadow 
                                                transition delay-150 duration-200 
                                                ease-in-out        
                                                flex 
                                                flex-no-wrap   
                                             `}>
                                        <Link href="/shubh-dina">
                                            <span className='text-nowrap '> Shubh Dina</span>
                                        </Link>
                                    </li>}
                                    {(BASE_CLASS === "footer") && <li className={`${BASE_CLASS}__nav-links__link cursor-pointer 
                                                hover:text-[#ebe793] hover:text-shadow 
                                                transition delay-150 duration-200 
                                                ease-in-out           
                                             `}>
                                        <Link href="/rashifal">Rashifal</Link>
                                    </li>}
                                    {(BASE_CLASS === "footer") && <li className={`${BASE_CLASS}__nav-links__link cursor-pointer 
                                                hover:text-[#ebe793] hover:text-shadow 
                                                transition delay-150 duration-200 
                                                ease-in-out           
                                             `}>
                                        <Link href="/learn-more-web">Learn More</Link>
                                    </li>}
                                </ul>
                            </div>
                            <div className={`resources-nav-bar flex flex-col  gap-[8px] md:items-center  font-bold  ${noto_sans.className} tracking-[0.05rem] text-white text-[1rem]`}>
                                <ul className='flex flex-col gap-[12px] '>
                                    <li className='text-[#B7C988] mb-2'>
                                        COMPANY
                                    </li>
                                    <li className={`${BASE_CLASS}__nav-links__link cursor-pointer 
                                                    hover:text-[#ebe793] hover:text-shadow 
                                                    transition delay-150 duration-200 
                                                    ease-in-out
                                                    `}>
                                        <Link href="/about-us">About Us</Link>
                                    </li>
                                </ul>
                                <ul className='flex flex-col gap-[12px] ml-0 md:ml-8 lg:ml-8 mt-4'>
                                    <li className='text-[#B7C988] mb-2'>
                                        LEGAL
                                    </li>
                                    {(BASE_CLASS === "footer") && <li className={`${BASE_CLASS}__nav-links__link 
                                            cursor-pointer hover:text-[#ebe793] 
                                            hover:text-shadow transition delay-150 
                                            duration-200 ease-in-out
                                       
                                            `}>
                                        <Link href="/policy">Privacy Policy</Link>
                                    </li>}
                                    {(BASE_CLASS === "footer") && <li className={`${BASE_CLASS}__nav-links__link 
                                            cursor-pointer hover:text-[#ebe793] 
                                            hover:text-shadow transition delay-150 
                                            duration-200 ease-in-out
                                       
                                            `}>
                                        <Link href="/terms-and-conditions">Terms of Use</Link>
                                    </li>}
                                </ul>
                            </div>
                            <div className={`${BASE_CLASS}__footer__social-media`}>
                                <ul className='flex flex-col gap-[12px] '>
                                    <li className='text-[#B7C988] font-bold mb-2'>
                                        SOCIAL LINKS
                                    </li>
                                    <li>
                                        <ul className={`${BASE_CLASS}__footer__social-media-links flex gap-5 lg:items-end justify-start`}>
                                            <li className={`${BASE_CLASS}__footer__nav-links__link bg-white rounded-full p-2`}>
                                                <Link href="https://www.instagram.com/dharmayana.app/" title="Follow us on Instagram" target='blank'>
                                                    <Image style={{ width: 'auto', height: 'auto' }}
                                                        src={`/instagram-new-icon.svg`}
                                                        alt="Follow us on Instagram" width={30} height={30} loading='lazy'
                                                    ></Image>
                                                </Link>
                                            </li>
                                            <li className={`${BASE_CLASS}__footer__nav-links__link bg-white rounded-full p-2`}>
                                                <Link href="https://www.linkedin.com/company/oit-innovations-pvt-ltd/" title='Follow us on Linkedin' target='blank'>
                                                    <Image style={{ width: 'auto', height: 'auto' }}
                                                        src={`/linkedin-new-icon.svg`}
                                                        alt="Follow us on Linkedin" width={30} height={30} loading='lazy'></Image>
                                                </Link>
                                            </li>
                                            <li className={`${BASE_CLASS}__footer__nav-links__link bg-white rounded-full p-2`}>
                                                <Link href={'https://www.youtube.com/@Dharmayana_app'} title='Subscribe to our YouTube Channel' target='blank'>
                                                    <Image style={{ width: 'auto', height: 'auto' }}
                                                        src={`/youtube-new-icon.svg`}
                                                        alt="Subscribe to our YouTube Channel" width={30} height={30} loading='lazy'></Image>
                                                </Link>
                                            </li>
                                            <li className={`${BASE_CLASS}__footer__nav-links__link bg-white rounded-full p-2`}>
                                                <Link href="https://www.facebook.com/profile.php?id=61578439461358" title='Follow our Facebook Page' target='blank'>
                                                    <Image style={{ width: 'auto', height: 'auto' }}
                                                        src={`/facebook-new-icon.svg`}
                                                        alt="Follow our Facebook Page" width={30} height={30} loading='lazy' ></Image>
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className=' px-10 lg:px-0'>
                        <Devider />
                    </div>
                    <div className='flex flex-col gap-[32px] ml-4 md:ml-0 align-center justify-start md:justify-center lg:flex-row text-[#FDF8E9]'>
                        <div className='flex flex-col gap-8 lg-gap-0 items-center'>
                            <div className='flex flex-col gap-4 md:gap-[4px] items-start md:items-center'>
                                <p>Made in 🇮🇳 with ❤️</p>
                                <p suppressHydrationWarning>Copyright © {new Date().getFullYear()} OIT Innovations Private Limited. All rights reserved</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default Footer